import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import { I18N_LANG } from './config/LSvars'
import {
  baseUrl,
  // basicAuthPassword, basicAuthUsername
} from './config/config'
// import intervalPlural from 'i18next-intervalplural-postprocessor'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  // .use(intervalPlural)
  .init({
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: I18N_LANG,
    },
    backend: {
      loadPath: `${baseUrl}/translations/{{lng}}.json`,
      // request: async (options, url, callback) => {
      //   const headers = new Headers(options.headers || {})
      //   headers.set(
      //     'Authorization',
      //     `Basic ${btoa(`${basicAuthUsername}:${basicAuthPassword}`)}`,
      //   )
      //   const response = await fetch(url, { ...options, headers })
      //   if (!response.ok) {
      //     callback(`Failed to load translations: ${response.statusText}`, false)
      //   } else {
      //     const data = await response.json()
      //     callback(null, { status: response.status, data })
      //   }
      // },
    },
    load: 'languageOnly',
    // lng: "uk", // if you're using a language detector, do not define the lng option
    fallbackLng: 'uk',
    keySeparator: false,
    debug: false,
    // debug: true,
  })

export default i18n

// info about plurals:
// https://www.i18next.com/translation-function/plurals
// https://jsfiddle.net/6bpxsgd4
